import { render } from "./FooterMenuComponent.vue?vue&type=template&id=d814bb9c&scoped=true"
import script from "./FooterMenuComponent.vue?vue&type=script&lang=js"
export * from "./FooterMenuComponent.vue?vue&type=script&lang=js"

import "./FooterMenuComponent.vue?vue&type=style&index=0&id=d814bb9c&lang=scss&scoped=true"

import exportComponent from "E:\\dive\\dive.fsd.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d814bb9c"]])

export default __exports__